export default {
  contacts: [],
  phone_types : [],
  autocomplete_data : [],
  autocomplete_selected : {},
  verticals : [],
  vertical_selected : {},
  countries : [],
  countries_selected : {},
  head_office_country_selected : {},
  contact_or_company:[],
  contact_or_company_no_selected : {},
  sub_roles:[],
  roles:[],
  seniorities:[]
}
